import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// Static content for searching
const FAQ_CONTENT = [
  { question: "What is UnsupervisedBias?", answer: "UnsupervisedBias is an AI-powered data accessibility consultation service...", path: "/faq" },
  { question: "How can I chat with Ubie?", answer: "Ubie is available to registered members. Click the chat bubble in the lower right corner after signing in.", path: "/faq" },
  { question: "Can I create a custom chatbot for my business?", answer: "Yes, we can create both internal and customer facing custom chatbots...", path: "/faq" },
  { question: "Can I put a chatbot bubble on my own website?", answer: "Yes, we can create a customer facing chatbot bubble for your website...", path: "/faq" },
  { question: "How does the custom AI chatbot work?", answer: "Upload your documents to the chatbot's knowledge base...", path: "/faq" },
  { question: "How do I upload more files to the chatbot?", answer: "Upload your documents using a drag-and-drop file upload system...", path: "/faq" },
  { question: "Are the documents that I upload to the chatbot kept private and secure?", answer: "Yes, your documents are kept private and secure...", path: "/faq" },
  { question: "How do I manage which files the chatbot has access to?", answer: "You can add and remove files from the folder...", path: "/faq" },
  { question: "How can I contact UnsupervisedBias?", answer: "You can reach us by email at support@unsupervisedbias.com", path: "/faq" }
];

const STATIC_PAGES = [
  {
    title: "Home",
    content: "Unleash True Business Efficiency with AI Automations. Orchestrate creative solutions for your customers. AI and Data Science automation services. Lead generation support chatbots automated data funnels video recognition.",
    path: "/"
  },
  {
    title: "About Us",
    content: "Welcome to UnsupervisedBias, your trusted partner in AI-driven data automation solutions. Our mission is to empower businesses like yours to achieve remarkable outcomes by harnessing the power of AI. Our Story. UnsupervisedBias was founded on the belief that AI can transform businesses. We are committed to developing innovative solutions that help businesses overcome obstacles, streamline operations, and unlock new possibilities. Experts in AI development and deployment dedicated to drive business success. Our Journey timeline history. December 2022 UnsupervisedBias was founded as an AI blog to share content with other developers. May 2023 Proof of concept for object detection and tracking from video sources was developed. This allows businesses to automate the collection of text, track objects to trigger alarms, and count objects in a space for monitoring dashboards. April 2024 AI chatbot that allows businesses to chat with their own internal documents was developed. Businesses also have the option to embed this chatbot within a chat icon on their websites.",
    path: "/about"
  },
  /* Services page temporarily hidden
  {
    title: "Services",
    content: "Browse our full catalog of AI-powered services. AI & Machine Learning services. Data Analysis. Automation services. Consulting. Chatbot Development custom chatbots. Infrastructure design and implementation. Categories: AI ML machine learning data analysis automation consulting chatbot infrastructure. Sort by popularity price name. Filter by category. Add to cart purchase buy services.",
    path: "/services"
  },
  */
  {
    title: "Contact",
    content: "Contact Us. Book a Discovery Call. Ready to explore how UnsupervisedBias can streamline your business operations and improve efficiency? Book a discovery call with us today. Our business offers AI-powered data automations, covering infrastructure design, integration, and implementation. We build scalable, reliable data foundations for your AI projects. Get in touch with UnsupervisedBias to learn how our AI solutions can streamline your operations. Contact form first name last name email phone number company name industry budget general inquiry project description. How did you hear about us friend family colleague Google Instagram YouTube Facebook LinkedIn Reddit Twitter Medium TikTok search engine. Subscribe to our Newsletter. Support UnsupervisedBias. Share our badge on your blog or website to support our brand with backlinking.",
    path: "/contact"
  },
  {
    title: "Blog",
    content: "Latest articles and insights about AI, machine learning, data science, automation, chatbots, technology trends, business solutions, artificial intelligence news and updates",
    path: "/blog"
  },
  {
    title: "FAQ Frequently Asked Questions",
    content: "Frequently asked questions. What is UnsupervisedBias? How can I demo the chatbot? Can I create a custom chatbot for my business? Can I put a chatbot bubble on my own website? How does the custom AI chatbot work? How do I upload more files to the chatbot? Are documents kept private and secure? How do I manage which files the chatbot has access to? How can I contact UnsupervisedBias?",
    path: "/faq"
  }
];

const HELP_TOPICS = [
  { title: "My Account Profile", content: "Manage Account settings. Update your profile information. Edit personal details first name last name email phone number company name industry job title bio interests project ideas. Change profile image avatar picture. Email preferences notifications newsletter subscription comment notifications document notifications. Verify email address. Add additional email addresses switch primary email. Account management user settings preferences", path: "/profile" },
  { title: "Add Email Address", content: "Add additional email addresses to your account. Manage multiple emails. Verify email. Switch primary email address. Set default sign in email", path: "/profile" },
  { title: "Change Primary Email", content: "Set a different email as your primary sign in email address. Switch default email. Update main email address for your account", path: "/profile" },
  /* Cart temporarily hidden
  { title: "Shopping Cart", content: "View and manage items in your cart. Shopping cart checkout. Review order. Remove items from cart. Update quantity. Proceed to checkout purchase buy services. View cart total subtotal", path: "/cart" },
  */
  { title: "Sign In", content: "Sign in to your account. Enter email and password. Keep me signed in. Remember me. Access your account dashboard", path: "/signin" },
  { title: "Create Account Register", content: "Register for a new account. Create account sign up join. Enter email password first name last name. New user registration. Become a member", path: "/create-account" },
  { title: "Forgot Password Reset", content: "Reset your password. Forgot password. Recover account access. Password reset link. Change password. Lost password recovery", path: "/forgot-password" },
  { title: "Verify Email", content: "Verify your email address. Email verification. Confirm email. Activate account. Verification link token", path: "/" },
  { title: "Newsletter Subscription", content: "Subscribe to our newsletter. Email notifications. Marketing communications. Stay updated with latest news articles blog posts", path: "/profile" },
  { title: "Book Discovery Call Schedule Meeting", content: "Book a discovery call. Schedule meeting consultation appointment. Talk to expert. Free consultation. Get in touch reach out", path: "/contact" }
];

const SearchOverlay = ({ isOpen, onClose }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState({ services: [], posts: [], faq: [], pages: [], help: [] });
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    const performSearch = async () => {
      if (!searchQuery.trim()) {
        setSearchResults({ services: [], posts: [], faq: [], pages: [], help: [] });
        return;
      }

      setLoading(true);
      try {
        const query = searchQuery.toLowerCase();

        // Search static content (FAQ, pages, help)
        const faqResults = FAQ_CONTENT.filter(item =>
          item.question.toLowerCase().includes(query) ||
          item.answer.toLowerCase().includes(query)
        ).slice(0, 3);

        const pageResults = STATIC_PAGES.filter(item =>
          item.title.toLowerCase().includes(query) ||
          item.content.toLowerCase().includes(query)
        ).slice(0, 3);

        const helpResults = HELP_TOPICS.filter(item =>
          item.title.toLowerCase().includes(query) ||
          item.content.toLowerCase().includes(query)
        ).slice(0, 3);

        // Services search temporarily hidden until services are ready
        /* const servicesResponse = await axios.get('/api/core/services/', {
            params: { search: searchQuery }
        }); */
        const postsResponse = await axios.get('/api/blog/posts/', {
            params: { search: searchQuery }
        });

        setSearchResults({
          services: [], // services: temporarily hidden
          posts: Array.isArray(postsResponse.data)
            ? postsResponse.data.slice(0, 3)
            : (postsResponse.data.results || []).slice(0, 3),
          faq: faqResults,
          pages: pageResults,
          help: helpResults
        });
      } catch (error) {
        console.error('Search error:', error);
        // Still show static results even if API fails
        const query = searchQuery.toLowerCase();
        setSearchResults({
          services: [],
          posts: [],
          faq: FAQ_CONTENT.filter(item =>
            item.question.toLowerCase().includes(query) ||
            item.answer.toLowerCase().includes(query)
          ).slice(0, 3),
          pages: STATIC_PAGES.filter(item =>
            item.title.toLowerCase().includes(query) ||
            item.content.toLowerCase().includes(query)
          ).slice(0, 3),
          help: HELP_TOPICS.filter(item =>
            item.title.toLowerCase().includes(query) ||
            item.content.toLowerCase().includes(query)
          ).slice(0, 3)
        });
      } finally {
        setLoading(false);
      }
    };

    const debounceTimer = setTimeout(performSearch, 300);
    return () => clearTimeout(debounceTimer);
  }, [searchQuery]);

  const handleResultClick = (type, item) => {
    onClose();
    setSearchQuery('');
    if (type === 'service') {
      // Services temporarily hidden — no-op
    } else if (type === 'post') {
      navigate(`/blog/${item.slug}`);
    } else if (type === 'faq' || type === 'page' || type === 'help') {
      navigate(item.path);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  // Close search when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      const searchContainer = document.getElementById('search-dropdown-container');
      if (isOpen && searchContainer && !searchContainer.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const totalResults = searchResults.services.length + searchResults.posts.length +
                       searchResults.faq.length + searchResults.pages.length + searchResults.help.length;

  return (
    <div
      id="search-dropdown-container"
      style={{
        position: 'fixed',
        top: '70px',
        right: '16px',
        width: '400px',
        maxWidth: 'calc(100vw - 32px)',
        background: 'rgba(20, 20, 30, 0.98)',
        backdropFilter: 'blur(10px)',
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
        zIndex: 9999,
        animation: 'slideDown 0.2s ease'
      }}
    >
      <style>
        {`
          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      {/* Search Container */}
      <div>
        {/* Search Input */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          padding: '15px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--pink)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ flexShrink: 0 }}
          >
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
          <input
            ref={inputRef}
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            style={{
              flex: 1,
              background: 'transparent',
              border: 'none',
              outline: 'none',
              color: '#fff',
              fontSize: '15px',
              fontFamily: 'inherit'
            }}
          />
        </div>

        {/* Search Results */}
        {searchQuery && (
          <div style={{
            maxHeight: '400px',
            overflowY: 'auto',
            padding: '10px'
          }}>
            {loading ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '14px' }}>
                Searching...
              </div>
            ) : totalResults === 0 ? (
              <div style={{ textAlign: 'center', color: '#999', padding: '20px', fontSize: '14px' }}>
                No results found
              </div>
            ) : (
              <>
                {/* Services Results */}
                {searchResults.services.length > 0 && (
                  <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                      color: 'var(--pink)',
                      fontSize: '0.75rem',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      padding: '0 5px'
                    }}>
                      Services
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      {searchResults.services.map((service) => (
                        <div
                          key={service.id}
                          onClick={() => handleResultClick('service', service)}
                          style={{
                            padding: '10px',
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          }}
                        >
                          <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '4px'
                          }}>
                            <h4 style={{
                              color: 'var(--pink)',
                              fontSize: '0.9rem',
                              margin: 0,
                              fontWeight: '600'
                            }}>
                              {service.name}
                            </h4>
                            <span style={{
                              color: 'var(--pink)',
                              fontWeight: 'bold',
                              fontSize: '0.85rem'
                            }}>
                              ${Math.floor(service.price)}
                            </span>
                          </div>
                          <p style={{
                            color: '#aaa',
                            fontSize: '0.8rem',
                            margin: 0,
                            lineHeight: '1.3',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical'
                          }}>
                            {service.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Blog Posts Results */}
                {searchResults.posts.length > 0 && (
                  <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                      color: 'var(--pink)',
                      fontSize: '0.75rem',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      padding: '0 5px'
                    }}>
                      Blog Posts
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      {searchResults.posts.map((post) => (
                        <div
                          key={post.id}
                          onClick={() => handleResultClick('post', post)}
                          style={{
                            padding: '10px',
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          }}
                        >
                          <h4 style={{
                            color: 'var(--pink)',
                            fontSize: '0.9rem',
                            margin: '0 0 4px 0',
                            fontWeight: '600'
                          }}>
                            {post.title}
                          </h4>
                          <p style={{
                            color: '#aaa',
                            fontSize: '0.8rem',
                            margin: 0,
                            lineHeight: '1.3',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical'
                          }}>
                            {post.excerpt || post.content?.substring(0, 100)}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* FAQ Results */}
                {searchResults.faq.length > 0 && (
                  <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                      color: 'var(--pink)',
                      fontSize: '0.75rem',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      padding: '0 5px'
                    }}>
                      FAQ
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      {searchResults.faq.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleResultClick('faq', item)}
                          style={{
                            padding: '10px',
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          }}
                        >
                          <h4 style={{
                            color: 'var(--pink)',
                            fontSize: '0.9rem',
                            margin: '0 0 4px 0',
                            fontWeight: '600'
                          }}>
                            {item.question}
                          </h4>
                          <p style={{
                            color: '#aaa',
                            fontSize: '0.8rem',
                            margin: 0,
                            lineHeight: '1.3',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical'
                          }}>
                            {item.answer}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Pages Results */}
                {searchResults.pages.length > 0 && (
                  <div style={{ marginBottom: '15px' }}>
                    <h3 style={{
                      color: 'var(--pink)',
                      fontSize: '0.75rem',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      padding: '0 5px'
                    }}>
                      Pages
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      {searchResults.pages.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleResultClick('page', item)}
                          style={{
                            padding: '10px',
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          }}
                        >
                          <h4 style={{
                            color: 'var(--pink)',
                            fontSize: '0.9rem',
                            margin: '0 0 4px 0',
                            fontWeight: '600'
                          }}>
                            {item.title}
                          </h4>
                          <p style={{
                            color: '#aaa',
                            fontSize: '0.8rem',
                            margin: 0,
                            lineHeight: '1.3'
                          }}>
                            {item.content}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Help & Account Results */}
                {searchResults.help.length > 0 && (
                  <div>
                    <h3 style={{
                      color: 'var(--pink)',
                      fontSize: '0.75rem',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      letterSpacing: '1px',
                      padding: '0 5px'
                    }}>
                      Help & Account
                    </h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                      {searchResults.help.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleResultClick('help', item)}
                          style={{
                            padding: '10px',
                            background: 'rgba(255, 255, 255, 0.03)',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                          }}
                        >
                          <h4 style={{
                            color: 'var(--pink)',
                            fontSize: '0.9rem',
                            margin: '0 0 4px 0',
                            fontWeight: '600'
                          }}>
                            {item.title}
                          </h4>
                          <p style={{
                            color: '#aaa',
                            fontSize: '0.8rem',
                            margin: 0,
                            lineHeight: '1.3'
                          }}>
                            {item.content}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchOverlay;
